<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:pushStatus="{ row }">
        <el-tag
          size="small"
          :type="
            row.pushStatus === '0'
              ? 'warning'
              : row.pushStatus === '1'
              ? 'success'
              : 'danger'
          "
        >
          {{ row.v_pushStatus }}
        </el-tag>
      </template>
      <template v-slot:errorEmailNotificationStatus="{ row }">
        <el-tag
          size="small"
          :type="
            row.errorEmailNotificationStatus === '0' && row.pushStatus === '2'
              ? 'danger'
              : row.errorEmailNotificationStatus === '1'
              ? 'success'
              : ''
          "
        >
          {{ row.v_errorEmailNotificationStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_view_details') || '查看详情'"
            placement="top"
          >
            <i class="el-icon-view tool-btn" @click="detail(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_view_retry') || '重试'"
            placement="top"
            v-if="row.pushStatus === '2' && allow('R')"
          >
            <i class="el-icon-refresh-right tool-btn" @click="retry(row)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('btn_view_send_email') || '邮件通知'"
            placement="top"
            v-if="row.pushStatus === '2' && allow('S')"
          >
            <i class="el-icon-message tool-btn" @click="sendEmail(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  methods: {
    detail({ subsOrderEventLogCode }) {
      this.$emit('showDetail', subsOrderEventLogCode)
    },
    async sendEmail({ subsOrderEventLogCode }) {
      const confirm = await this.$confirm(
        this.$l('tips_confirm_sendWarehouse') || '是否要发送异常通知邮件？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api.ecomPlatformSubsOrderEvnetLogsSendMessageApi({
        subsOrderEventLogCode,
      })
      this.loadingClose()
      if (!res) return
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || res.msg,
        type: 'success',
      })
      this.$emit('reload')
    },
    retry({ subsOrderEventLogCode }) {
      this.loadingOpen()
      this.$api
        .ecomPlatformSubsOrderEvnetLogsRetryApi({
          subsOrderEventLogCode,
        })
        .then((res) => {
          this.loadingClose()
          const { status, msg } = res
          if (status !== 200) {
            this.$message.error(msg)
            return
          }
          this.$message({
            showClose: true,
            message: msg,
            type: 'success',
          })
          this.$emit('reload')
        })
        .catch(() => {
          this.loadingClose()
        })
    },
  },
}
</script>
